import axios from "axios";
import { toast } from "react-toastify";

const API_POINT = process.env.REACT_APP_FORM_API_ROUTE;
const tenantId = process.env.REACT_APP_TENANT_ID;

const HTTPRequest = axios.create({
  baseURL: process.env.REACT_APP_FORM_API_URL,
});

const HTTPRequestForServer = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL + '/api/v1/intake',
  // headers: {
  //   "ngrok-skip-browser-warning": true
  // }
});

export const GET_QUESTIONNAIRES_AND_LOCATIONS = async (tenantId) => {
  try {

    const response = await HTTPRequestForServer.get(
      `/tenant/${tenantId}/questionnaires`
    );

    if(response?.data){
        return response?.data;
    }

  } catch (error) {
    console.error("Error fetching questionnaires:", error);
  } 
};

export const GET_QUESTIONNAIRE = async (id, tenantId) => {
  //   const headers={
  //   "ngrok-skip-browser-warning": true
  // }
  try {
    const response = await HTTPRequest.get(
      `/${API_POINT}/${tenantId}/crai/render/${id}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching questionnaire:", error);
  }
};

export const SUBMIT_QUESTIONNAIRE_RESPONSE = async ({ data = {} }) => {
  // const headers = {
  //   "ngrok-skip-browser-warning": true,
  // };
  try {
    const response = await HTTPRequest.post(
      `/${API_POINT}/tenants/${tenantId}/facebook-campaign/submit`,
      data,
      // { headers }
    );
    return response;
  } catch (error) {
    console.error("Error submitting questionnaire response:---", error);
    toast?.error(
      error?.response?.data?.details?.message ||
        "Error submitting questionnaire response"
    );
    throw error;
  }
};

export const GET_QUESTIONNAIRE_CONTEXT = async ({ id = "", tenantId = "" }) => {
  //   const headers={
  //   "ngrok-skip-browser-warning": true
  // }
  try {
    const response = await HTTPRequest.get(
      `/${"assistants"}/${tenantId}/get_context/sessionid/${id}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching questionnaire:", error);
  }
};

export const startVerifyOTP = async ({ phoneNumber = "" }) => {
  try {
    const response = await axios.post(
      "https://verify-9433-aubqel.twil.io/start-verify",
      new URLSearchParams({
        channel: "sms",
        locale: "en",
        to: phoneNumber,
      }),
      {
        headers: {
          accept: "*/*",
          "accept-language": "en-US,en;q=0.5",
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          origin: "https://verify-9433-aubqel.twil.io",
          priority: "u=1, i",
          referer: "https://verify-9433-aubqel.twil.io/index.html",
          "sec-ch-ua":
            '"Brave";v="143", "Chromium";v="143", "Not A(Brand";v="24"',
          "sec-ch-ua-mobile": "?0",
          "sec-ch-ua-platform": '"Windows"',
          "sec-fetch-dest": "empty",
          "sec-fetch-mode": "cors",
          "sec-fetch-site": "same-origin",
          "sec-gpc": "1",
          "user-agent":
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        },
      }
    );

    console.log("startVerifyOTP response:", response);
    return response;
  } catch (error) {
    console.error("Error starting OTP verification:", error);
    throw error;
  }
};

export const checkVerifyOTP = async ({ phoneNumber = "", code = "" }) => {
  try {
    const response = await axios.post(
      "https://verify-9433-aubqel.twil.io/check-verify",
      new URLSearchParams({
        to: phoneNumber,
        code: code,
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Accept: "*/*",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error checking OTP verification:", error);
    throw error;
  }
};
